/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
document.addEventListener("DOMContentLoaded", function() {
    console.log("✅ Script custom.js chargé !");

    // Sélectionne les boutons radio des variantes
    let variantInputs = document.querySelectorAll("input[data-single-option-selector]");

    // Sélectionne l'élément où afficher les dimensions
    let dimensionsDiv = document.getElementById("variant-dimensions");

    if (!dimensionsDiv) {
        console.warn("⚠️ L'élément #variant-dimensions est introuvable dans le HTML.");
        return;
    }

    variantInputs.forEach(input => {
        input.addEventListener("change", function() {
            let selectedVariant = document.querySelector("input[data-single-option-selector]:checked");
let variantId = selectedVariant && selectedVariant.id ? selectedVariant.id.replace(/\s+/g, '-').toLowerCase() : null;
            if (selectedVariant) {
                let dimensions = selectedVariant?.metafields?.custom?.dimensions || "Aucune dimension trouvée."; console.log("🟢 Dimensions récupérées :", dimensions);
                
                if (dimensions && dimensions !== "null") {
                    dimensionsDiv.innerHTML = `📏 Dimensions : ${dimensions}`;
                    console.log("✅ Dimensions de la variante :", dimensions);
                } else {
                    dimensionsDiv.innerHTML = "📏 Dimensions non spécifiées.";
                    console.warn("⚠️ Aucune dimension trouvée pour cette variante.");
                }
            }
        });
    });
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
